import React, { useState } from 'react';
import Button from '@/components/atomics/Button';
import styles from './FeedbackForm.module.scss';
import Icon from '@/components/atomics/Icons';
import { Select } from '@/components/atomics';
import Textarea from '@/components/atomics/Textarea';
import FeedbackData, { FeedbackFormData } from '@/types/Feedback';
import { AppContext } from '@/App';

const className = 'feedback-form';

type FeedbackFormProps = {
  feedback: FeedbackData;
  onCancel?: () => void;
  loading?: boolean;
  onSubmit: (data: FeedbackFormData) => void;
};

const FeedbackForm: React.FC<FeedbackFormProps> = ({
  feedback,
  onCancel,
  onSubmit
}) => {
  const [status, setStatus] = useState(feedback?.reviewStatus);
  const [notes, setNotes] = useState('');
  const appContext = React.useContext(AppContext);
  const admin = appContext?.admin as { level?: number } | undefined;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // if (onSubmit) onSubmit({ fileBase64 });
    onSubmit({
      feedbackCurrentId: feedback?.feedbackCurrentId,
      reviewStatus: status,
      reviewNote: notes,
    });
  };

  return (
    <form className={styles[className]} data-testid="isolirform"
      onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <h5>Pastikan masukan pengguna telah dipahami sebelum memperbarui status.</h5>
      <Select disabled={feedback?.reviewStatus === 'done' || admin?.level === 3} label="Status" options={[
        {
          text: 'Done',
          value: 'done'
        },
        {
          text: 'To Do',
          value: 'todo'
        }
      ]} onChange={(e) => setStatus(e.target.value)} value={status} />
      <Textarea disabled={feedback?.reviewStatus === 'done' || admin?.level === 3} label="Catatan"
        onChange={e => setNotes(e.target.value)} value={feedback?.reviewStatus === 'done' ? feedback?.reviewNote :notes}
        placeholder="Isi dengan catatan action plan/PIC/solusi masalah" />
      <div className={styles[className + '__buttons']}>
        <Button onClick={onCancel} variant="outline-secondary">
          Batal
        </Button>
        <Button disabled={feedback?.reviewStatus === 'done'} type="submit" variant="primary">
          Submit
        </Button>
      </div>
    </form>
  );
};

export default FeedbackForm;